import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getReasonsCloudSolutions(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Vysoká úroveň zabezpečení",
			desc: "Bezpečnost vašich dat je pro nás na prvním místě. Moderní cloudové platformy sp[[nabízí šifrování, vícefaktorovou autentizaci a další bezpečnostní opatření.]]",
		},
		{
			title: "Škálovatelnost cloudu",
			desc: "sp[[Cloud se přizpůsobí růstu vašeho podnikání.]] Jeho kapacitu snadno upravíte podle aktuálních potřeb.",
		},
		{
			title: "Zálohování a obnova dat",
			desc: "Automatizované zálohování sp[[minimalizuje riziko ztráty dat a v případě jakýchkoliv komplikací umožňuje jejich okamžitou obnovu.]]",
		},
		{
			title: "Přístup odkudkoliv na světě",
			desc: "Pokud máte data a aplikace na cloudu, nezáleží, kde zrovna jste – sp[[vy i vaši zaměstnanci budete mít ke vzdálenému úložišti přístup kdykoliv a kdekoliv.]]",
		},
		{
			title: "Rychlé zprovoznění",
			desc: "Implementace cloudových řešení sp[[je výrazně rychlejší než zprovoznění fyzické infrastruktury.]] Nemusíte se tak bát zbytečných průtahů a komplikací.",
		},
		{
			title: "Úspora nákladů",
			desc: "Když máte data na cloudu, sp[[nevyhazujete peníze za údržbu fyzických úložišť ve firmě.]] Platíte pouze za služby, které skutečně využíváte.",
		},
	];
}
